import React from 'react';
import { Card, Text } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import { TextByCountry } from 'commons/components';
import {
  formatCuit,
  getCuitOrCuilLabel,
  useTranslationWithPrefix,
} from 'commons/utils';
import BankAccountSkeleton from './BankAccountSkeleton';

interface InterfaceBankAccount {
  bankAccountInfo: {
    fiscalNumber: string;
    beneficiary: string;
    accountNumber: string;
    bank: string;
  };
}

function BankAccount({ bankAccountInfo }: InterfaceBankAccount): JSX.Element {
  const { t } = useTranslationWithPrefix('transfer.bankAccount');

  const document = bankAccountInfo.fiscalNumber;

  return (
    <Card>
      <DataList bottomDivider={false}>
        <DataList.Row
          topDivider={false}
          paddingX="none"
          paddingBottom="2"
          paddingTop="none"
        >
          <TextByCountry
            AR={`${getCuitOrCuilLabel(document)}`}
            BR={`${getCuitOrCuilLabel(document)}`}
            MX={`${t('rfc')}`}
          />
          <TextByCountry
            fontWeight="bold"
            AR={formatCuit(document)}
            BR={formatCuit(document)}
            MX={document}
          />
        </DataList.Row>
        <DataList.Row paddingX="none" paddingY="2">
          <Text>{t('beneficiaryName')}</Text>
          <Text fontWeight="bold">{bankAccountInfo.beneficiary}</Text>
        </DataList.Row>
        <DataList.Row paddingX="none" paddingY="2">
          <Text>{t('bank')}</Text>
          <Text fontWeight="bold">{bankAccountInfo.bank}</Text>
        </DataList.Row>
        <DataList.Row paddingX="none" paddingTop="2" paddingBottom="none">
          <Text>{t('accountNumber')}</Text>
          <Text fontWeight="bold">{bankAccountInfo.accountNumber}</Text>
        </DataList.Row>
      </DataList>
    </Card>
  );
}

BankAccount.Skeleton = BankAccountSkeleton;
export default BankAccount;
